import script from "./SelectOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectOptions.vue?vue&type=script&setup=true&lang=js"

import "./SelectOptions.vue?vue&type=style&index=0&id=23b0d956&lang=scss"

const __exports__ = script;

export default __exports__